<template>
  <b-container fluid class="page-wrapper px-0">
    <div class="overlay"></div>
    <b-navbar toggleable="md" type="light" variant="default" fixed="top" class="shadow">
      <b-navbar-brand to="/" class="d-flex align-items-center">
        <img class="nav-logo mr-3" src="@/assets/jhp-logo.webp"/>
        <span>JHP-Company</span>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav  >
          <b-nav-item to="/" exact active-class="active">Startseite</b-nav-item>
          <b-nav-item to="/katalog" active-class="active">Katalog</b-nav-item>
          <b-nav-item to="/aktuelles" active-class="active">Aktuelles</b-nav-item>
          <b-nav-item to="/preise" active-class="active">Preise</b-nav-item>
          <b-nav-item to="/about" active-class="active">Über uns</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right menu-class="shadow-lg">
            <!-- Using 'button-content' slot -->
            <template #button-content>
              <b-icon-cart /> 
              <span v-if="shoppingCart.length > 0" class="cart-notify bg-secondary text-white"> {{shoppingCart.length}} </span>
            </template>
            <!-- <b-dropdown-item href="#">Profile</b-dropdown-item>
            <b-dropdown-item href="#">Sign Out</b-dropdown-item> -->
            <b-dropdown-item v-if="shoppingCart.length == 0" disabled>
              <em class="text-secondary m-3">
                Keine Bilder im Einkaufswagen
              </em>
            </b-dropdown-item>
            <template v-else> 
              <h4 class="mx-3 mt-3">Einkaufswagen</h4>
							<div class="cart-content">
								<div v-for="(image, index) in shoppingCart" :key="`image-${index}`" 
									class="d-flex ml-3 mr-2 my-3 justify-content-between align-items-center cart-item" style="color: var(--font-color-link)" >
									<div class="d-flex flex-column align-items-start">
										<b>{{ image.name }}</b>
										<div class="mt-n1" style="color: var(--font-color-inactive)"> 
											<small class="ml-auto mr-2">
												{{ image.size }} | 
												{{ (image.forRent)? 'Mieten' : 'Kaufen' }} | 
												{{ (image.forRent)? 'inkl. Rahmen' : ((image.withFrame)? 'mit Rahmen' : 'ohne Rahmen') }}
											</small>
										</div>
									</div>
									<span class="ml-auto mr-3">
										{{ ((sizePrice[image.forRent][image.size] + ((!image.forRent && image.withFrame)? framePrice[image.size] : 0)) * image.count).toFixed(2).replace('.', ',') }}€
									</span>
									<b-input v-model="image.count" class="mr-2" style="width: 3.5rem;" 
										type="number" min="1" size="sm" @change="saveCart" />
									<button class="remove-btn" @click="shoppingCart.splice(index, 1); sortCart()">x</button>
								</div>
							</div>
              <div class="w-100 px-3 py-2">
                <b-btn class="w-100 text-white" variant="primary" @click="showOrderModal = true">
                  Zum Formular ({{ getTotalCost().toFixed(2).replace('.', ',') }}€)
                </b-btn>
              </div>
            </template>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <b-container fluid class="content-wrapper px-0 px-lg-3">
      <b-row no-gutters align-h="center">
        <b-col lg="3" class="px-2 px-lg-2 px-xl-5 d-none d-lg-block">
          <transition name="custom-fade">
            <b-card v-if="$route.name == 'Home'" no-body class="shadow">
              <div class="w-100 d-flex justify-content-center bg-default">
                <h5 class="my-2">
                  <b>Beliebte Kategorien</b>
                </h5>
              </div>

              <b-alert v-if="error" class="m-3 text-center" variant="danger" show>
                {{error}}
              </b-alert>
              <b-list-group v-else style="position: relative" flush>
                <div v-if="trendingCategories.length == 0" class="thumb-spinner d-flex justify-content-center my-3" 
                  style="position: relative">
                  <b-spinner class="align-self-center" variant="primary"></b-spinner>
                </div>
                <b-list-group-item v-else v-for="category in trendingCategories" :key="category.id" :to="'/katalog#c' + category.id"
                  class="category-item">
                  <b-row no-gutters align-h="start" align-v="center">
                    <b-col cols="auto">
                      <div class="icon-wrapper shadow-sm">
                        <div class="thumb-spinner d-flex justify-content-center">
                          <b-spinner class="align-self-center" variant="primary"></b-spinner>
                        </div>
                        <b-icon-folder-fill v-if="category.thumbLocation == ''" class="category-icon"/>
                        <div v-else class="category-icon" :style="{ backgroundImage: `url(${category.thumbLocation})` }" ></div>
                      </div>
                    </b-col>
                    <b-col class="ml-3" cols="auto">
                      <h6 class="mb-0 font-weight-bold">{{category.name}}</h6>
                    </b-col>
                  </b-row>
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </transition>
        </b-col>
        <b-col cols="12" lg="6">
          <b-container>
            <transition name="custom-fade" mode="out-in">
              <router-view class="content-view bg-default shadow" @add-cart-item="addCartItem"></router-view>
            </transition>
          </b-container>
        </b-col>
        <b-col cols="12" md="5" lg="3" class="px-3 px-lg-2 px-xl-5 mt-5 mt-lg-0">
          <transition name="custom-fade">
            <b-card v-if="$route.name == 'Home'" no-body class="shadow">
              <div class="w-100 d-flex justify-content-center bg-default">
                <h5 class="my-2">
                  <b>Neue Beiträge</b>
                </h5>
              </div>

              <b-alert v-if="error" class="m-3 text-center" variant="danger" show>
                {{error}}
              </b-alert>
              <b-list-group v-else style="position: relative" flush>
                <div v-if="newArticles.length == 0" class="thumb-spinner d-flex justify-content-center my-3" style="position: relative">
                  <b-spinner class="align-self-center" variant="primary"></b-spinner>
                </div>
                <b-list-group-item v-else v-for="article in newArticles" :key="article.id" :to="'/aktuelles#a' + article.id"
                  class="category-item d-flex align-items-center justify-content-between">
                  <h6 class="mb-0 font-weight-bold">{{article.title}}</h6>
                  <small style="min-width: 6rem; text-align: right;">{{parseDate(article.publishDate)}}</small>
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </transition>
        </b-col>
        <b-col cols="12" md="5" class="px-3 mt-5 d-lg-none">
          <transition name="custom-fade">
            <b-card v-if="$route.name == 'Home'" no-body class="shadow">
              <div class="w-100 d-flex justify-content-center bg-default">
                <h5 class="my-2">
                  <b>Beliebte Kategorien</b>
                </h5>
              </div>

              <b-alert v-if="error" class="m-3 text-center" variant="danger" show>
                {{error}}
              </b-alert>
              <b-list-group v-else style="position: relative" flush>
                <div v-if="trendingCategories.length == 0" class="thumb-spinner d-flex justify-content-center my-3" style="position: relative">
                  <b-spinner class="align-self-center" variant="primary"></b-spinner>
                </div>
                <b-list-group-item v-else v-for="category in trendingCategories" :key="category.id" :to="'/katalog#c' + category.id"
                  class="category-item">
                  <b-row no-gutters align-h="start" align-v="center">
                    <b-col cols="auto">
                      <div class="icon-wrapper shadow-sm">
                        <div class="thumb-spinner d-flex justify-content-center">
                          <b-spinner class="align-self-center" variant="primary"></b-spinner>
                        </div>
                        <b-icon-folder-fill v-if="category.thumbLocation == ''" class="category-icon"/>
                        <div v-else class="category-icon" :style="{ backgroundImage: `url(${category.thumbLocation})` }" ></div>
                      </div>
                    </b-col>
                    <b-col class="ml-3" cols="auto">
                      <h6 class="mb-0 font-weight-bold">{{category.name}}</h6>
                    </b-col>
                  </b-row>
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </transition>
        </b-col>
      </b-row>
    </b-container>

    <!-- Order Modal -->
    <b-modal v-model="showOrderModal" centered title="Bestellformular" scrollable ok-variant="primary text-white"
      ok-title="Senden" cancel-title="Abbrechen" :ok-disabled="!selectedOrderName || modalLoading"
      @ok="sendOrder" @show="prepareOrderModal" no-close-on-esc no-close-on-backdrop :cancel-disabled="modalLoading"
      hide-header-close>
      <transition name="custom-fade" mode="out-in">
        <div v-if="!orderSuccess" key="1" class="w-100">
          <b-alert :show="orderError" variant="danger">
            Beim Senden Ihrer Bestellung ist leider ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.
          </b-alert>
          <b-form-group label="Name">
            <b-form-input v-model="selectedOrderName" placeholder="Vorname & Nachname oder Firmenname" :disabled="modalLoading" />
          </b-form-group>
          <b-form-group label="E-Mail">
            <b-form-input v-model="selectedOrderEmail" placeholder="Kontakt E-Mail eingeben (optional)" type="email" :disabled="modalLoading"/>
          </b-form-group>
          <b-form-group label="Anmerkungen">
            <b-textarea v-model="selectedOrderNotes" placeholder="Anmerkungen, Fragen oder Wünsche (optional)" :disabled="modalLoading" />
          </b-form-group>

          <b-form-group label="Bestellung">
            <div v-for="(image, index) in shoppingCart" :key="`image-${index}`" 
              class="d-flex px-3 my-2 justify-content-between align-items-center cart-item w-100"
							style="color: var(--font-color-link)" >
              <span class="mr-3">{{ image.count }}x</span>
              <div class="d-flex flex-column align-items-start">
                <b>{{ image.name }}</b>
                <div class="mt-n1"
									style="color: var(--font-color-inactive)"> 
                  <small class="ml-auto mr-2">
                    {{ image.size }} | 
                    {{ (image.forRent)? 'Mieten' : 'Kaufen' }} | 
                    {{ (image.forRent)? 'inkl. Rahmen' : ((image.withFrame)? 'mit Rahmen' : 'ohne Rahmen') }}
                  </small>
                </div>
              </div>
              <span class="ml-auto">
                {{ (image.forRent)? 'monatlich' : '' }} {{ ((sizePrice[image.forRent][image.size] + ((!image.forRent && image.withFrame)? framePrice[image.size] : 0)) * image.count).toFixed(2).replace('.', ',') }}€
              </span>
            </div>
          </b-form-group>
        </div>
        <div v-else key="2" class="d-flex flex-column justify-content-center align-items-center" 
          style="height: 10rem">
          <b-icon-check-circle variant="success" class="h1" />
          <b>Vielen Dank für Ihre Bestellung</b>
          <b>Wir werden uns, wenn nötig, in Kürze bei Ihnen melden</b>
        </div>
      </transition>
    </b-modal>

    <!-- Footer -->
    <footer class="footer shadow bg-default" style="bottom: 0px;">
      <b-container fluid class="p-4" style="text-align: center;">
        <router-link to="/impressum" class="link">Impressum</router-link>
      
        <hr class="my-3" style="width: 11rem;"/>

        <b-row class="mx-auto" align-h="center" no-gutters>
          <b-col cols="auto">
            <a href="https://www.instagram.com/jhp.company" target="_blank" class="link mx-3"><b-icon-instagram class="mr-2"/>jhp.company</a>
          </b-col>
          <b-col cols="auto">
            <a href="https://www.facebook.com/JHP-Company-313856832631374/" target="_blank" class="link mx-3"><b-icon-facebook class="mr-2"/>JHP-Company</a>
          </b-col>
          <b-col cols="auto">
            <a href="https://www.youtube.com/channel/UCKhTf3X0NJoUZZiakSPeQHg/" target="_blank" class="link mx-3"><b-icon-youtube class="mr-2"/>JHP-Company Stadtroda</a>
          </b-col>
          <b-col cols="auto">
            <a href="https://goo.gl/maps/oECCxC2bpuX6nhcH7" target="_blank" class="link mx-3"><b-icon-geo-alt-fill class="mr-2"/>Schlossstraße 15, 07646 Stadtroda</a>
          </b-col>
          <b-col cols="auto">
            <a href="mailto:service@jhp-company-stadtroda.de" target="_blank" class="link mx-3"><b-icon-envelope-fill class="mr-2"/>service@jhp-company-stadtroda.de</a>
          </b-col>
        </b-row>

        <hr class="my-3" style="width: 11rem;"/>

				<div>
					<a @click="switchTheme('light')" class="link mx-2">
						<b-icon-sun-fill v-if="currentTheme == 'light'" />
						<b-icon-sun v-else />
					</a>
					<a @click="switchTheme('dark')" class="link mx-2">
						<b-icon-moon-fill v-if="currentTheme == 'dark'"/>
						<b-icon-moon v-else/>
					</a>
				</div>
      </b-container>
    </footer>
  </b-container>
</template>

<script>
export default {
  mounted() {
		this.currentTheme = document.documentElement.getAttribute('data-theme');

    this.fetchData();
    this.shoppingCart = JSON.parse(localStorage.getItem('shopping-cart')) ?? [];
    this.sortCart();
  },
  data() {
    return {
			currentTheme: 'light',
      trendingCategories: [],
      newArticles: [],
      shoppingCart: [],
      showOrderModal: false,
      error: '',
      orderError: false,
      orderSuccess: false,
      modalLoading: false,
      selectedOrderEmail: '',
      selectedOrderName: '',
      selectedOrderNotes: '',
      sizePrice: {
        'false': {
          'S': 8,
          'M': 14,
          'L': 22,
          'XL': 27,
          'XXL': 32,
        },
        'true': {
          'S': 3,
          'M': 3.50,
          'L': 4.00,
          'XL': 5.50,
        }
      },
      framePrice: {
        'S': 0,
        'M': 10,
        'L': 18,
        'XL': 21,
        'XXL': 25
      }
    }
  },
  methods: {
    fetchData: async function() {
      this.error = '';

      try {
        let result = await this.axios.get('/api/article', {
          params: {
            new: true, 
            nocontent: true
          }
        });
        
        this.newArticles = result.data ?? [];
        this.newArticles = this.newArticles.filter(e => e.visible);

        result = await this.axios.get('/api/imagecategory', {
          params: {
            trending: true
          }
        });
        
        this.trendingCategories = result.data ?? [];
        this.trendingCategories = this.trendingCategories.filter(e => e.visible);
      } catch (error) {
        this.error = 'Fehler beim Laden der Daten';
      }

			if(process.env.NODE_ENV === 'development') {
				this.error = null;

				// eslint-disable-next-line no-useless-escape
				this.trendingCategories = [{"id":"13","name":"Abstrakt","description":"Hier werden Bilder dargestellt, die nachtr\u00e4glich synthetisiert wurden.","visible":true,"parentCategory":"0","thumbLocation":"\/images\/catalog\/thumb\/abstrakt03.jpg","pageHits":"82"},{"id":"14","name":"Energie","description":"","visible":true,"parentCategory":"0","thumbLocation":"\/images\/catalog\/thumb\/energie06.jpg","pageHits":"22"},{"id":"29","name":"Kunstwerke","description":"","visible":true,"parentCategory":"0","thumbLocation":"","pageHits":"22"},{"id":"15","name":"Forsth\u00e4user","description":"","visible":true,"parentCategory":"0","thumbLocation":"\/images\/catalog\/thumb\/forsthaus18.jpg","pageHits":"18"},{"id":"30","name":"B\u00e4ume","description":"","visible":true,"parentCategory":"29","thumbLocation":"\/images\/catalog\/thumb\/baum01.jpg","pageHits":"17"},{"id":"45","name":"Zeichnungen","description":"","visible":true,"parentCategory":"29","thumbLocation":"\/images\/catalog\/thumb\/zeichnung09.jpg","pageHits":"17"}];
				this.newArticles = [{"id":"22","title":"Sch\u00fclerfirmenDigital Berlin 2019","year":"2","visible":true,"publishDate":"1572048000000","isSpecial":null,"editSource":false,"preview":"Im Fr\u00fchjahr dieses Jahres erhielten wir von der Deutschen Kinder- und Jugendstiftung das Angebot, uns am Projekt #Sch\u00fclerfirmenDigital zu beteiligen. Unsere Sch\u00fclerfirma existiert"},{"id":"21","title":"Sch\u00fclerfirmenDigital-Projekt 2019","year":"2","visible":true,"publishDate":"1567029600000","isSpecial":null,"editSource":false,"preview":"Am Mittwoch, den 28.8.2019 haben sich Fabian Pfundmeier und Andreas Siegmann die Zeit f\u00fcr uns genommen, um einen Digitalworkshop mit uns durchzuf\u00fchren. Nach einer kleinen Vorstellungsrunde"},{"id":"20","title":"Die Einl\u00f6sung unseres 1. Preises","year":"2","visible":true,"publishDate":"1561068000000","isSpecial":null,"editSource":false,"preview":"Am 20. Juni 2019 war es endlich soweit. Wir konnten unsere Belohnung f\u00fcr den 1. Preis des Ministerpr\u00e4sidenten einl\u00f6sen. F\u00fcr unsere h\u00f6chst erfolgreiche Teilnahme an der Gr\u00fcndermesse"},{"id":"17","title":"Zukunftsweisende Projekte 2019 des Landkreises","year":"2","visible":true,"publishDate":"1559512800000","isSpecial":null,"editSource":false,"preview":"Wir hatten uns mit dem Konzept der JHP-Company f\u00fcr den Preis des Landrates \"Zukunftsweisende Projekte 2019\" beworben und unsere Unterlagen p\u00fcnktlich zum 31.03.2019 eingereicht. Unser"},{"id":"18","title":"Sch\u00fclerfirmen-Gipfel 2019","year":"2","visible":true,"publishDate":"1554933600000","isSpecial":null,"editSource":false,"preview":"Am Donnerstag dem 11.4.2019 sind wir, vier Sch\u00fcler der JHP- Company, nach Jena zum 8. Sch\u00fclerfirmen-Gipfel der Nachhaltigkeit gefahren. Nachdem wir eine Einleitung zum Thema Nachhaltigkeit"},{"id":"19","title":"Ausstellung in Holzhausen 2019","year":"2","visible":true,"publishDate":"1554933600000","isSpecial":null,"editSource":false,"preview":"Unseren Kontakt nach Holzhausen zum Otto Kn\u00f6pfer Haus kn\u00fcpften wir bei der Ignition im M\u00e4rz 2019. Uns wurden vier R\u00e4ume in diesem Haus zur Verf\u00fcgung gestellt in denen wir unsere"}]
			}
		},
    dateToDDMMYYYY: function(date) {
        let dateObj = new Date(parseInt(date));

        let day = dateObj.getDate();
        let month = dateObj.getMonth();
        month = month + 1;
        if((String(day)).length == 1)
        day = '0' + day;
        if((String(month)).length == 1)
        month = '0' + month;

        return (day+ '.' + month + '.' + dateObj.getFullYear());
    },
    parseDate: function(date) {
      const diffTime = Math.abs(new Date() - new Date(parseInt(date)));
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) - 1; 

      if(diffDays > 6)
        return this.dateToDDMMYYYY(date);
      else if(diffDays <= 6 && diffDays != 0)
        return `Vor ${diffDays} ${(diffDays > 1)? 'Tagen' : 'Tag'}`;
      else
        return 'Vor kurzem';
    },
    addCartItem: function(value) {
      console.log(value);
			
			// check if image already is in cart and if so, increment it
			let item = this.shoppingCart.filter(e => { 
				return e.name == value.name && e.size == value.size && e.forRent == value.forRent && e.withFrame == value.withFrame;
			})[0];
			
			if(item)
				item.count++;
			else 
				this.shoppingCart.push(value);
      
			this.sortCart();
    },
    getTotalCost: function() {
      let cost = 0;

      for(let image of this.shoppingCart) {
        cost += ((this.sizePrice[image.forRent][image.size] + ((!image.forRent && image.withFrame)? this.framePrice[image.size] : 0)) * image.count)
      }

      return cost;
    },
    sortCart: function() {
      this.shoppingCart.sort((a, b) => {
        if (a.name < b.name)
          return -1;
        if (a.name > b.name)
          return 1;

        return 0;
      });
    },
    prepareOrderModal: function() {
      this.orderError = false;
      this.orderSuccess = false;
      this.selectedOrderName = '';
      this.selectedOrderEmail = '';
      this.selectedOrderNotes= '';
    },
    sendOrder: async function(bvModalEvt) {
      bvModalEvt.preventDefault();

      this.modalLoading = true;

      try {
        let result = await this.axios.post('/api/order', {
          name: this.selectedOrderName,
          email: this.selectedOrderEmail,
          notes: this.selectedOrderNotes,
          order: this.shoppingCart
        });
        console.log(result);

        this.orderSuccess = true;
        this.orderError = false;

        setTimeout(() => {
          this.modalLoading = false;
          this.showOrderModal = false;
        }, 5000);

        // clear cart
        localStorage.removeItem('shopping-cart');
        this.shoppingCart = [];
      } catch (error) {
        console.log(error);
        this.orderError = true;
        this.modalLoading = false;
      }
    },
    saveCart: function() {
      localStorage.setItem('shopping-cart', JSON.stringify(this.shoppingCart));
    },
		//function that changes the theme, and sets a localStorage variable to track the theme between page loads
		switchTheme: function(theme) {
			if(this.currentTheme == theme) return;

			localStorage.setItem('theme', theme);
			document.documentElement.setAttribute('data-theme', theme);
			
			this.currentTheme = theme;
		}
  },
  watch: {
    shoppingCart: function () {
      this.saveCart();
    }
  },
}
</script>

<style>
	/* root/default variables */
	:root {
		--font-color: #444;
		--font-color-title: rgb(20, 20, 20);
		--font-color-inactive: rgba(0, 0, 0, 0.5);
		--font-color-link: #555;
		--bg-color: #f7f7f7;
		--card-bg: #fff;
		--custom-white: #fff;
		--custom-black: #000;
		--custom-grey: 204, 204, 204;
		--hover: #eee;
		--overlay: rgba(255, 255, 255, 0.2);
		--hamburger-border: rgba(0, 0, 0, 0.1);
		--hamburger-filter: ;
	}

	/* dark theme */
	[data-theme="dark"] {
		--font-color: rgb(215, 215, 215);
		--font-color-title: rgb(230, 230, 230);
		--font-color-inactive: rgb(170, 170, 170);
		--font-color-link: rgb(190, 190, 190);
		--bg-color: #1e1e1e;
		--card-bg: rgb(40, 40, 40);
		--custom-white: var(--bg-color); 
		--custom-black: #ccc;
		--custom-grey: 85, 85, 85;
		--hover: #383838;
		--overlay: rgba(40, 40, 40, 0.4);
		--hamburger-border: rgba(255, 255, 255, 0.2);
		--hamburger-filter: invert(92%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(91%) contrast(90%);;
	}

	/* Bootstrap color theme overrides */
	.bg-default {
		background-color: var(--bg-color) !important;
	}

	.nav-link {
		color: var(--font-color-inactive) !important;
	}

	.navbar-brand {
    color: var(--font-color-title) !important;
	}

	.nav-link.active {
		color: var(--font-color-title) !important;
	}

	.dropdown-item.disabled {
		color: var(--font-color-inactive) !important;
	}

	.form-control {
    color: var(--font-color) !important;
		background-color: var(--custom-white) !important;
		border: 1px solid var(--secondary) !important
	}

	.card {
		background-color: var(--card-bg) !important;
	}

	.list-group-item-action {
    color: var(--font-color-link) !important;
	}
	
	.list-group-item {
		background-color: unset !important;
		border-color: rgba(var(--custom-grey), 0.8) !important;
	}
	
	.list-group-item:hover {
		background-color: var(--hover) !important;
	}

	.modal-content {
		background-color: var(--bg-color) !important;
	}

	.dropdown-menu {
		background-color: var(--bg-color) !important;
		color: var(--font-color) !important;
		border: 1px solid var(--secondary) !important
	}

	.close {
		color: var(--custom-black) !important;
	}

	.custom-select {
		background: var(--custom-white) !important;
		color: var(--font-color) !important;
		border: 1px solid var(--secondary) !important
	}
	
	.link {
		color: var(--font-color-link);
    transition: 0.1s;
	}

	.link:hover {
		color: var(--primary);
		cursor: pointer;
	}

	.table {
		color: var(--font-color) !important;
	}

	.card {
		border-color: rgba(var(--custom-grey), 0.8) !important;
	}

	.table th, .table td {
		border-color: rgb(var(--custom-grey)) !important;
	}

	.navbar-light .navbar-toggler {
		filter: var(--hamburger-filter);
	}

	.navbar-light .navbar-toggler-icon {
		border-color: var(--hamburger-border) !important;
	}

	.modal-header, .modal-footer {
		border-color: rgb(var(--custom-grey)) !important;
	}

	::placeholder {
		color: var(--font-color-inactive) !important;
		opacity: 1;
	}

  html, body {
    height: 100%;
  }

  body {
    background: url('./assets/background.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;
		background-color: var(--bg-color) !important;

    position: relative;

    overflow-y: scroll !important;

    color: var(--font-color) !important;
  }

  .custom-fade-enter-active, .custom-fade-leave-active {
    transition: 0.1s;
  }

  .custom-fade-enter, .custom-fade-leave-to {
    opacity: 0;
  }

  .page-wrapper {
    position: relative; 

    display: flex;
    flex-direction: column;

    height: 100%;
  }

  .content-wrapper {
    flex: 1 0 auto;
    margin: 6.5rem 0;
    z-index: 2;
  }

  .icon-wrapper {
    position: relative;
    height: 3rem;
    width: 3rem;

    margin-left: -0.4rem;
  }

  .overlay {
    background-color: var(--overlay);
    height: 100vh;
    width: 100vw;
    position: fixed;
    z-index: 1;
  }

  a {
    transition: 0.1s;
  }

  .thumb-spinner {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    z-index: 10;
  }

  .category-icon {
    height: 100%;
    width: 100%;

    border-radius: 0.25rem;

    background-size: cover;
    background-position: center;

    position: relative;

    z-index: 55;
  }

  .category-item {
    min-height: 4rem !important;
  }

  .navbar.transparent, .transparent {
    background-color: rgba(130, 130, 130, 0.85) !important;
  }

  .nav-logo {
    width: 1.9rem;
    height: 2.1rem;
  }

  .nav-link {
    transition: 0.1s;
  }

  .content-view {
    /* margin: 6.5rem 0.5rem 3.5rem 0.5rem !important;
    width: calc(100% - 1rem) !important; */
    border-radius: 0.25rem;

    position: relative;
    z-index: 52;
  }

  .blur {
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
  }

  hr {
    color: var(--font-color-link); /* old IE */
    background-color: var(--font-color-link); /* Modern Browsers */
  }

  .footer {
    position: relative;
    z-index: 50;
    flex-shrink: 0;
  }

  .modal-open {
    overflow-y: scroll !important;
		padding-right: 0 !important;
  }

	.modal.show {
		-webkit-backdrop-filter: blur(2px);
		backdrop-filter: blur(2px);
	}

  .remove-btn {
    width: 1.9rem;
    height: 1.9rem;
    border: none;
    background: none;
    color: gray;
    font-weight: bold;
    transition: 0.2s;
  }

  .remove-btn:focus {
    outline: none;
  }

  .remove-btn:hover {
    color: #FF0000;
  }

  .cart-item {
    max-width: calc(100vw - 4rem);
    width: 22rem;
  }

  .cart-notify {
    border-radius: 1rem;
    margin-left: 0.2rem;
  }

  .ck-content img {
    border-radius: 0.25rem;
	}

  .ck-content .image_resized {
		position: relative;
    width: calc(100% - 1rem) !important;
		margin: 0.5rem;
  }

	.navbar-collapse {
    overflow-y: auto;
    max-height: calc(100vh - 10rem);
	}

	@media only screen and (min-width: 768px) {
		.cart-content {
			max-height: calc(100vh - 13rem); overflow-y: auto;
		}

		.navbar-collapse {
			overflow-y: unset;
			max-height: unset;
		}
	}

	@media only screen and (min-width: 800px) {
		.ck-content .image_resized {
			flex: 0 0 50%;
			max-width: calc(50% - 1rem);
		}
	}
</style>
